export const NAME = 'confirm';
